<div class="modal-content">
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="modal.hide()"><span aria-hidden="true">&times;</span></button>
    <h3 class="modal-title">Balanço Patrimonial</h3>
  </div>
  <div class="modal-body">
    <section class="content">
      <div class="info">
        <span class="info-title">Ativo Disponível
          <saiba-mais
          [isPopoverOnHover]="true"
          [isPositionStatic]="true"
          [isSmall]="true"
          [titulo]="'Ajuda'"
          [texto]='"Campo \"Soma valor em caixa e bancos hoje\", da tela Dados Financeiros do Empreendimento"'></saiba-mais>
        </span>
        <span class="info-value">{{ model?.ativoDisponivel | currency:'BRL':'symbol':'1.2-2' }}</span>
      </div>
      <div class="info">
        <span class="info-title">Contas a Receber
          <saiba-mais
          [isPopoverOnHover]="true"
          [isPositionStatic]="true"
          [isSmall]="true"
          [titulo]="'Ajuda'"
          [texto]='"Campo \"Contas a receber\", da tela Dados Financeiros do Empreendimento"'></saiba-mais>
        </span>
        <span class="info-value">{{ model?.contasAReceber | currency:'BRL':'symbol':'1.2-2' }}</span>
      </div>
      <div class="info">
        <span class="info-title">Estoque de produtos e Matéria-prima
          <saiba-mais
          [isPopoverOnHover]="true"
          [isPositionStatic]="true"
          [isSmall]="true"
          [titulo]="'Ajuda'"
          [texto]='"Campo \"Estoque\", da tela Dados Financeiros do Empreendimento"'></saiba-mais>
        </span>
        <span class="info-value">{{ model?.estoqueProdutosMateriaPrima | currency:'BRL':'symbol':'1.2-2' }}</span>
      </div>
      <div class="info">
        <span class="info-title">Imobilizado
          <saiba-mais
          [isPopoverOnHover]="true"
          [isPositionStatic]="true"
          [isSmall]="true"
          [titulo]="'Ajuda'"
          [texto]='"Somatória dos campos \"Estoque\" e \"Máquinas e equipamentos\" da tela Dados Financeiros do Empreendimento"'></saiba-mais>
        </span>
        <span class="info-value">{{ model?.imobilizado | currency:'BRL':'symbol':'1.2-2' }}</span>
      </div>
      <div class="info">
        <span class="info-title-upper">Total do Ativo
          <saiba-mais
          [isPopoverOnHover]="true"
          [isPositionStatic]="true"
          [isSmall]="true"
          [titulo]="'Ajuda'"
          [texto]='"Somatória dos campos \"Ativo Disponível\", \"Contas a Receber\", \"Estoque de Produtos e Matéria-prima\" e \"Imobilizado\""'></saiba-mais>
        </span>
        <span class="info-value">{{ model?.totalAtivo | currency:'BRL':'symbol':'1.2-2' }}</span>
      </div>
      <div class="info">
        <span class="info-title">Passivo Circulante
          <saiba-mais
          [isPopoverOnHover]="true"
          [isPositionStatic]="true"
          [isSmall]="true"
          [titulo]="'Ajuda'"
          [texto]='"Somatória dos campos \"Dívidas com fornecedores\" e \"Contas a pagar em geral\" da tela Dados Financeiros do Empreendimento"'></saiba-mais>
        </span>
        <span class="info-value">{{ model?.passivoCirculante | currency:'BRL':'symbol':'1.2-2' }}</span>
      </div>
      <div class="info">
        <span class="info-title">Empréstimos
          <saiba-mais
          [isPopoverOnHover]="true"
          [isPositionStatic]="true"
          [isSmall]="true"
          [titulo]="'Ajuda'"
          [texto]='"Total de crédito informado no campo \"Em quais instituições?\" da tela “Dados do empreendimento"'></saiba-mais>
        </span>
        <span class="info-value">{{ model?.emprestimos | currency:'BRL':'symbol':'1.2-2' }}</span>
      </div>
      <div class="info">
        <span class="info-title">Patrimonio Líquido
          <saiba-mais
          [isPopoverOnHover]="true"
          [isPositionStatic]="true"
          [isSmall]="true"
          [titulo]="'Ajuda'"
          [texto]='"\"Total de ativo\" - \"Passivo Circulante\" - \"Empréstimos\" da tela Dados Financeiros do Empreendimento"'></saiba-mais>
        </span>
        <span class="info-value">{{ model?.patrimonioLiquido | currency:'BRL':'symbol':'1.2-2' }}</span>
      </div>
      <div class="info">
        <span class="info-title-upper">Total do passivo
          <saiba-mais
          [isPopoverOnHover]="true"
          [isPositionStatic]="true"
          [isSmall]="true"
          [titulo]="'Ajuda'"
          [texto]='"Somatória dos campos \"Passivo Circulante\", \"Empréstimos\" e \"Patrimonio Líquido\""'></saiba-mais>
        </span>
        <span class="info-value">{{ model?.totalPassivo | currency:'BRL':'symbol':'1.2-2' }}</span>
      </div>
    </section>
  </div>
  <div class="modal-footer centered">
    <button class="btn btn-border-orange" (click)="modal.hide()">Fechar</button>
  </div>
</div>
